/**
 * Shared input hints so mobile keyboards and browser autofill behave well.
 * Keyed by the form field `name` used across the site's forms.
 */
const AUTOCOMPLETE: Record<string, string> = {
  first_name: "given-name",
  last_name: "family-name",
  name: "name",
  email: "email",
  phone: "tel",
  phone_number: "tel",
  address1: "address-line1",
  address2: "address-line2",
  address_line1: "address-line1",
  address_line2: "address-line2",
  city: "address-level2",
  state: "address-level1",
  state_province: "address-level1",
  postal_code: "postal-code",
  country: "country-name",
  date_of_birth: "bday",
  emergency_contact_number: "tel",
  amount: "off",
};

const INPUT_MODE: Record<string, "text" | "email" | "tel" | "numeric" | "decimal"> = {
  email: "email",
  phone: "tel",
  phone_number: "tel",
  emergency_contact_number: "tel",
  postal_code: "numeric",
  amount: "decimal",
  quantity: "numeric",
};

export function autoCompleteFor(name: string): string | undefined {
  return AUTOCOMPLETE[name];
}

export function inputModeFor(
  name: string,
): "text" | "email" | "tel" | "numeric" | "decimal" | undefined {
  return INPUT_MODE[name];
}
